import * as React from 'react';

const SvgDragAndDrop = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.12"
      d="M7.7998 3.59961H16.2002C17.0498 3.59961 17.651 3.6003 18.1211 3.63867C18.5842 3.67651 18.8676 3.74811 19.0898 3.86133C19.5414 4.0914 19.9086 4.45863 20.1387 4.91016C20.2519 5.13234 20.3235 5.41576 20.3613 5.87891C20.3997 6.34896 20.4004 6.9502 20.4004 7.7998V8.40039H3.59961V7.7998C3.59961 6.9502 3.6003 6.34896 3.63867 5.87891C3.67651 5.41575 3.74812 5.13234 3.86133 4.91016C4.09141 4.45865 4.45865 4.09141 4.91016 3.86133C5.13234 3.74812 5.41575 3.67651 5.87891 3.63867C6.34896 3.6003 6.9502 3.59961 7.7998 3.59961Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="M3 9H21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9.125V21M15 9.125V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
      stroke="#6D659D"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgDragAndDrop;
